import { FileText, Play } from "lucide-react";
import { PUBLIC_BLOG_POSTS } from "../data/publicBlogPosts";
import { youtubeThumbnailUrl } from "../lib/youtubeVideos";

const ND1_INSIGHT_EXTRAS = {
  "/blog/applying-for-jobs-is-broken": { duration: "12:45" },
};

/** Map shared blog posts into ND1 insight card props. */
export function getNd1Insights() {
  return PUBLIC_BLOG_POSTS.map((post) => {
    const isVideo = post.type === "Video";
    const extras = ND1_INSIGHT_EXTRAS[post.href] || {};

    return {
      kind: isVideo ? "video" : "article",
      tag: post.type,
      icon: isVideo ? Play : FileText,
      title: post.title,
      copy: post.copy,
      cta: isVideo ? "Watch now" : "Read article",
      href: post.href,
      image:
        post.previewImage ||
        (post.previewVideoId ? youtubeThumbnailUrl(post.previewVideoId) : null),
      alt: post.previewAlt || post.title,
      duration: extras.duration || null,
    };
  });
}
